import { ProjectIssuanceConstants } from "../../../constants";
import {
  ProjectIssuanceBNGPanelData,
  ProjectIssuanceCarbonPanelData,
  ProjectIssuanceNNPanelData,
} from "../../../models";

/**
 * The blank issuance a measurement starts from.
 *
 * One resolver rather than the same ternary at three call sites: they were already identical, and a
 * fourth measurement would otherwise have to be added to each. Carbon stays the fall-through, so an
 * unrecognised measurement behaves exactly as it does today.
 *
 * Lives here rather than in the hook so it can be tested without loading the hook's service imports:
 * those reach the identity service, which is ESM-only and aborts a targeted `react-scripts test` run
 * that has not been given the package script's transform configuration.
 */
export const getDefaultIssuanceForMeasurement = (
  unitMeasurement: string | undefined
): ProjectIssuanceCarbonPanelData | ProjectIssuanceBNGPanelData | ProjectIssuanceNNPanelData => {
  if (unitMeasurement === ProjectIssuanceConstants.ISSUANCE_UNIT_MEASUREMENT_BIODIVERSITY) {
    return ProjectIssuanceConstants.DEFAULT_BNG_ISSUANCE;
  }
  if (unitMeasurement === ProjectIssuanceConstants.ISSUANCE_UNIT_MEASUREMENT_NUTRIENT_NEUTRALITY) {
    return ProjectIssuanceConstants.DEFAULT_NN_ISSUANCE;
  }
  return ProjectIssuanceConstants.DEFAULT_CARBON_ISSUANCE;
};
